<template>
  <div
    class="alert"
    :class="[
      ...config[type].classes,
      !isCloseButtonVisible && '-no-close-button',
    ]"
  >
    <svg v-if="isIconVisible" class="ico">
      <use :xlink:href="`/images/svg-symbols.svg#${config[type].icon}`"/>
    </svg>
    <div class="alert__content">
      <slot></slot>
    </div>
    <button
      v-if="isCloseButtonVisible" type="button"
      class="closeAlert" @click.prevent="$emit('close-notification')"
    >
      <svg class="ico">
        <use xlink:href="/images/svg-symbols.svg#close" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'warning',
    },
    canClose: {
      type: Boolean,
      required: false,
      default: null,
    },
    withIcon: {
      type: Boolean,
      required: false,
      default: null,
    },
  },

  computed: {
    isCloseButtonVisible() {
      return this.canClose === null ? this.config[this.type].canClose : this.canClose;
    },

    isIconVisible() {
      return this.withIcon === null ? this.config[this.type].icon : this.withIcon;
    }
  },

  data() {
    return {
      config: {
        warning: {
          icon: 'ico-alert-yellow',
          classes: ['-yellow'],
          canClose: true,
        },
        info: {
          icon: 'info-base',
          classes: ['-blue'],
          canClose: true,
        },
        danger: {
          icon: 'error',
          classes: ['-red'],
          canClose: false,
        },
      }
    }
  }
}
</script>
